"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var sdk_1 = require("./api/sdk");
var bignumber_js_1 = require("bignumber.js");
var logic_1 = require("./logic");
var buildTransaction = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var kit, value, celoTransaction, lockedGold, lockedGold, lockedGold, election, vote, election, accounts, voteSignerAccount, revokes, revoke, election, accounts, voteSignerAccount, activates, activate, accounts, celoToken, gas, tx, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                kit = (0, sdk_1.celoKit)();
                value = transactionValue(account, transaction);
                if (!(transaction.mode === "lock")) return [3 /*break*/, 3];
                return [4 /*yield*/, kit.contracts.getLockedGold()];
            case 1:
                lockedGold = _k.sent();
                _b = {
                    from: account.freshAddress,
                    value: value.toFixed(),
                    to: lockedGold.address,
                    data: lockedGold.lock().txo.encodeABI()
                };
                return [4 /*yield*/, lockedGold.lock().txo.estimateGas({
                        from: account.freshAddress,
                        value: value.toFixed()
                    })];
            case 2:
                celoTransaction = (_b.gas = _k.sent(),
                    _b);
                return [3 /*break*/, 31];
            case 3:
                if (!(transaction.mode === "unlock")) return [3 /*break*/, 6];
                return [4 /*yield*/, kit.contracts.getLockedGold()];
            case 4:
                lockedGold = _k.sent();
                _c = {
                    from: account.freshAddress,
                    to: lockedGold.address,
                    data: lockedGold.unlock(value).txo.encodeABI()
                };
                return [4 /*yield*/, lockedGold.unlock(value).txo.estimateGas({
                        from: account.freshAddress
                    })];
            case 5:
                celoTransaction = (_c.gas = _k.sent(),
                    _c);
                return [3 /*break*/, 31];
            case 6:
                if (!(transaction.mode === "withdraw")) return [3 /*break*/, 9];
                return [4 /*yield*/, kit.contracts.getLockedGold()];
            case 7:
                lockedGold = _k.sent();
                _d = {
                    from: account.freshAddress,
                    to: lockedGold.address,
                    data: lockedGold.withdraw(transaction.index || 0).txo.encodeABI()
                };
                return [4 /*yield*/, lockedGold.withdraw(transaction.index || 0).txo.estimateGas({
                        from: account.freshAddress,
                        value: value.toFixed()
                    })];
            case 8:
                celoTransaction = (_d.gas = _k.sent(),
                    _d);
                return [3 /*break*/, 31];
            case 9:
                if (!(transaction.mode === "vote")) return [3 /*break*/, 13];
                return [4 /*yield*/, kit.contracts.getElection()];
            case 10:
                election = _k.sent();
                return [4 /*yield*/, election.vote(transaction.recipient, new bignumber_js_1.BigNumber(value))];
            case 11:
                vote = _k.sent();
                _e = {
                    from: account.freshAddress,
                    to: election.address,
                    data: vote.txo.encodeABI()
                };
                return [4 /*yield*/, vote.txo.estimateGas({ from: account.freshAddress })];
            case 12:
                celoTransaction = (_e.gas = _k.sent(),
                    _e);
                return [3 /*break*/, 31];
            case 13:
                if (!(transaction.mode === "revoke")) return [3 /*break*/, 19];
                return [4 /*yield*/, kit.contracts.getElection()];
            case 14:
                election = _k.sent();
                return [4 /*yield*/, kit.contracts.getAccounts()];
            case 15:
                accounts = _k.sent();
                return [4 /*yield*/, accounts.voteSignerToAccount(account.freshAddress)];
            case 16:
                voteSignerAccount = _k.sent();
                return [4 /*yield*/, election.revoke(voteSignerAccount, transaction.recipient, new bignumber_js_1.BigNumber(value))];
            case 17:
                revokes = _k.sent();
                revoke = revokes.find(function (transactionObject) {
                    return (transactionObject.txo._method.name ===
                        (transaction.index === 0 ? "revokePending" : "revokeActive"));
                });
                if (!revoke)
                    throw new Error("No votes to revoke");
                _f = {
                    from: account.freshAddress,
                    to: election.address,
                    data: revoke.txo.encodeABI()
                };
                return [4 /*yield*/, revoke.txo.estimateGas({ from: account.freshAddress })];
            case 18:
                celoTransaction = (_f.gas = _k.sent(),
                    _f);
                return [3 /*break*/, 31];
            case 19:
                if (!(transaction.mode === "activate")) return [3 /*break*/, 25];
                return [4 /*yield*/, kit.contracts.getElection()];
            case 20:
                election = _k.sent();
                return [4 /*yield*/, kit.contracts.getAccounts()];
            case 21:
                accounts = _k.sent();
                return [4 /*yield*/, accounts.voteSignerToAccount(account.freshAddress)];
            case 22:
                voteSignerAccount = _k.sent();
                return [4 /*yield*/, election.activate(voteSignerAccount)];
            case 23:
                activates = _k.sent();
                activate = activates.find(function (a) { return a.txo.arguments[0] === transaction.recipient; });
                if (!activate)
                    throw new Error("No votes to activate");
                _g = {
                    from: account.freshAddress,
                    to: election.address,
                    data: activate.txo.encodeABI()
                };
                return [4 /*yield*/, activate.txo.estimateGas({
                        from: account.freshAddress
                    })];
            case 24:
                celoTransaction = (_g.gas = _k.sent(),
                    _g);
                return [3 /*break*/, 31];
            case 25:
                if (!(transaction.mode === "register")) return [3 /*break*/, 28];
                return [4 /*yield*/, kit.contracts.getAccounts()];
            case 26:
                accounts = _k.sent();
                _h = {
                    from: account.freshAddress,
                    to: accounts.address,
                    data: accounts.createAccount().txo.encodeABI()
                };
                return [4 /*yield*/, accounts
                        .createAccount()
                        .txo.estimateGas({ from: account.freshAddress })];
            case 27:
                celoTransaction = (_h.gas = _k.sent(),
                    _h);
                return [3 /*break*/, 31];
            case 28: return [4 /*yield*/, kit.contracts.getGoldToken()];
            case 29:
                celoToken = _k.sent();
                celoTransaction = {
                    from: account.freshAddress,
                    to: celoToken.address,
                    data: celoToken
                        .transfer(transaction.recipient, value.toFixed())
                        .txo.encodeABI()
                };
                return [4 /*yield*/, kit.connection.estimateGasWithInflationFactor(celoTransaction)];
            case 30:
                gas = _k.sent();
                celoTransaction = __assign(__assign({}, celoTransaction), { gas: gas });
                _k.label = 31;
            case 31:
                _a = [__assign({}, celoTransaction)];
                _j = {};
                return [4 /*yield*/, kit.connection.chainId()];
            case 32:
                _j.chainId = _k.sent();
                return [4 /*yield*/, kit.connection.nonce(account.freshAddress)];
            case 33:
                _j.nonce = _k.sent();
                return [4 /*yield*/, kit.connection.gasPrice()];
            case 34:
                tx = __assign.apply(void 0, _a.concat([(_j.gasPrice = _k.sent(), _j)]));
                return [2 /*return*/, tx];
        }
    });
}); };
var transactionValue = function (account, transaction) {
    var value = transaction.amount;
    if (transaction.useAllAmount) {
        if ((transaction.mode === "unlock" || transaction.mode === "vote") &&
            account.celoResources) {
            // Deduct the amount of pending vote transactions from
            // the total non-voting locked balance to get the true non-voting locked balance.
            var pendingOperationAmounts = (0, logic_1.getPendingStakingOperationAmounts)(account);
            var pendingOperationAmount = transaction.mode === "vote"
                ? pendingOperationAmounts.vote
                : new bignumber_js_1.BigNumber(0);
            value = account.celoResources.nonvotingLockedBalance.minus(pendingOperationAmount);
        }
        else if (transaction.mode === "revoke" && account.celoResources) {
            var revoke = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
            if (revoke === null || revoke === void 0 ? void 0 : revoke.amount)
                value = revoke.amount;
        }
        else {
            value = account.spendableBalance.minus(transaction.fees || 0);
        }
    }
    return value;
};
exports["default"] = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map